<template>
	<modal ref="modal">
		<template #title>Add New Material</template>
		<template #body>
			<div class="block" :class="{ 'block-mode-loading': form.processing }">
				<div class="row">
					<div class="col-lg-4 col-md-6">
						<div class="mb-4">
							<label class="form-label" for="avatar">Banner</label>
							<input
								@change="on_file_change"
								type="file"
								id="banner"
								class="form-control"
								accept="image/*"
							/>
						</div>
						<div class="mb-4">
							<div
								id="banner-preview"
								class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
								style="
									height: 200px;
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
								"
							/>
						</div>
					</div>
					<div class="col">
						<div class="mb-4">
							<label class="form-label">Title</label>
							<input
								v-model="form.title"
								type="text"
								class="form-control"
								:class="{ 'is-invalid': form.errors.title }"
							/>
							<div v-if="form.errors.title" class="invalid-feedback">
								{{ form.errors.title }}
							</div>
						</div>
						<div class="mb-4">
							<label class="form-label">Category</label>
							<select
								v-model="form.category"
								class="form-select"
								:class="{ 'is-invalid': form.errors.category }"
							>
								<option :value="null" selected>SELECT CATEGORY</option>
								<option
									v-for="(
										category, key, index
									) in collection.material_categories"
									:key="index"
									:value="key"
								>
									{{ category }}
								</option>
							</select>
							<div v-if="form.errors.category" class="invalid-feedback">
								{{ form.errors.category }}
							</div>
						</div>
						<div class="row">
							<div class="col">
								<div class="mb-4">
									<label class="form-label">Video Host</label>
									<select
										v-model="form.video_host"
										class="form-select"
										:class="{ 'is-invalid': form.errors.video_host }"
									>
										<option :value="null" selected>SELECT VIDEO HOST</option>
										<option
											v-for="(video_host, key, index) in collection.video_hosts"
											:key="index"
											:value="key"
										>
											{{ video_host }}
										</option>
									</select>
									<div v-if="form.errors.video_host" class="invalid-feedback">
										{{ form.errors.video_host }}
									</div>
								</div>
							</div>
							<div class="col">
								<div class="mb-4">
									<label class="form-label">Video ID</label>
									<input
										v-model="form.video_id"
										type="text"
										class="form-control"
										:class="{ 'is-invalid': form.errors.video_id }"
									/>
									<div v-if="form.errors.video_id" class="invalid-feedback">
										{{ form.errors.video_id }}
									</div>
								</div>
							</div>
						</div>
						<div class="mb-4">
							<label class="form-label">Message</label>
							<textarea
								v-model="form.message"
								class="form-control"
								rows="5"
							></textarea>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="mb-4">
									<label class="form-label">
										Material
										<small class="text-muted">(PDF File)</small>
									</label>
									<input
										@change="hande"
										type="file"
										id="pdf"
										class="form-control"
										:class="{ 'is-invalid': form.errors.pdf }"
										accept="application/pdf"
									/>
									<div v-if="form.errors.pdf" class="invalid-feedback">
										{{ form.errors.pdf }}
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="mb-4">
									<label class="form-label">Scheduled Post</label>
									<flat-pickr
										v-model="form.date_appear"
										:config="{
											enableTime: true,
											altInput: true,
											altFormat: 'M j, Y h:i K',
											dateFormat: 'Y-m-d H:i:s',
										}"
										class="form-control"
										:class="
											form.errors.date_appear
												? 'flatpickr-input is-invalid border-danger'
												: 'flatpickr-input'
										"
									/>
									<div v-if="form.errors.date_appear" class="invalid-feedback">
										{{ form.errors.date_appear }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="submit"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<i class="fa fa-save me-2"></i>Create Material
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				<i class="fa fa-times"></i>Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		collection: Object,
	},
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			card: null,
			title: null,
			category: null,
			video_host: null,
			video_id: null,
			message: null,
			pdf: null,
			date_appear: new Date(),
		})

		const on_file_change = (e) => {
			const banner_preview = document.getElementById('banner-preview')
			if (e.target.files.length > 0) {
				form.card = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				banner_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`
			} else {
				form.card = null
				banner_preview.innerHTML = ''
			}
		}

		const hande = (e) => {
			if (e.target.files.length > 0) {
				form.pdf = e.target.files[0]
			} else {
				form.pdf = null
			}
		}

		const submit = () => {
			form.post(route('admin.site-management.user-materials.store'), {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only: ['materials','api_response','errors'],
				onSuccess: () => {
					form.reset()
					toggleModal()
					document.getElementById('banner-preview').innerHTML = ''
					document.getElementById('banner').value = null
					document.getElementById('pdf').value = null
				},
			})
		}

		return {
			form,
			modal,
			submit,
			toggleModal,
			on_file_change,
			hande,
		}
	},
}
</script>
